import { render, staticRenderFns } from "./ForceChangePassword.vue?vue&type=template&id=21bc6c80&scoped=true&lang=pug&"
import script from "./ForceChangePassword.vue?vue&type=script&lang=ts&"
export * from "./ForceChangePassword.vue?vue&type=script&lang=ts&"
import style0 from "./ForceChangePassword.vue?vue&type=style&index=0&id=21bc6c80&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bc6c80",
  null
  
)

export default component.exports